module.exports = __webpack_public_path__ + "static/media/plus_icon.78e050e9.svg";